import { render, staticRenderFns } from "./IncludeClosedAccommodatiesSearch.vue?vue&type=template&id=6786d3f0&"
import script from "./IncludeClosedAccommodatiesSearch.vue?vue&type=script&lang=js&"
export * from "./IncludeClosedAccommodatiesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports